import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './UpdatePostingMutation.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePostingMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  commentArticleV1?: Types.InputMaybe<Array<Types.ArticlesCreateArticleBlocksInput> | Types.ArticlesCreateArticleBlocksInput>;
  publishAt?: Types.InputMaybe<Types.Scalars['Date']['input']>;
}>;


export type UpdatePostingMutation = (
  { __typename?: 'Mutation' }
  & { postingsUpdatePosting?: Types.Maybe<(
    { __typename?: 'PostingsPostingMutationResult' }
    & { success?: Types.Maybe<(
      { __typename?: 'PostingsPosting' }
      & Pick<Types.PostingsPosting, 'id' | 'comment'>
    )>, error?: Types.Maybe<(
      { __typename?: 'PostingsError' }
      & Pick<Types.PostingsError, 'message' | 'details'>
    )> }
  )> }
);


export type UpdatePostingMutationFn = Apollo.MutationFunction<UpdatePostingMutation, UpdatePostingMutationVariables>;

/**
 * __useUpdatePostingMutation__
 *
 * To run a mutation, you first call `useUpdatePostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostingMutation, { data, loading, error }] = useUpdatePostingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      commentArticleV1: // value for 'commentArticleV1'
 *      publishAt: // value for 'publishAt'
 *   },
 * });
 */
export function useUpdatePostingMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostingMutation, UpdatePostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostingMutation, UpdatePostingMutationVariables>(Operations.UpdatePosting, options);
      }
export type UpdatePostingMutationHookResult = ReturnType<typeof useUpdatePostingMutation>;
export type UpdatePostingMutationResult = Apollo.MutationResult<UpdatePostingMutation>;
export type UpdatePostingMutationOptions = Apollo.BaseMutationOptions<UpdatePostingMutation, UpdatePostingMutationVariables>;